export default "__VITE_ASSET__CkS1lSxS__"